//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/IFacet.js";
import "../no/ugmath.js";
let d=[[[0,"IsValid",0,0],[0,"OwningFace",0,"Face",0],[0,"Vertex0",1,0],[0,"Vertex1",1,0],[0,"Vertex2",1,0]],[[["numPoints"],"GetVertices",{R_:{points:""}},0,0],[["edgeIndex"],"GetAdjacentFacet",{R_:{adjacentFacet:"ConvergentFacet"}},1,0],[["numVertices"],"GetVertexNormals",{R_:{vertexNormals:""}},0,0],[[],"GetUnitNormal",{R_:{unitNormal:''}},0,0],[["points"],"SetVertices",{},1,0],[["planeNormal","dCoefficient"],"GetPlaneEquation",{},0,0],[[],"Destroy",{},0,0]],[]];
SPLM.ConvergentFacet = class extends SPLM.IFacet{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ConvergentFacet";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;